import React, { createContext, useCallback, useEffect, useState } from 'react';
import DialogUpdateVersionContext from '../components/_dashboard/olimpo/versiones/UpdateVersion/DialogUpdateVersionContext';
import { firestore } from './FirebaseContext';

export const VersionContext = createContext({ versionApp: '', updateVersion: () => {} });

function VersionProvider({ children }) {
  const [versions, setVersions] = useState([]);
  const [dialogVersion, setDialogVersion] = useState(false);
  const [versionApp, setVersionApp] = useState('');

  // console.log('versions', versions);

  const updateVersion = () => {
    if (versions.length) {
      const lastVersion = versions[0];
      localStorage.setItem('versionApp', lastVersion.version);
      // window.location.reload(true);
      caches
        .keys()
        .then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))))
        .then(() => window.location.reload(true));
    }
    // window.location.reload(true);
    caches
      .keys()
      .then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))))
      .then(() => window.location.reload(true));
  };

  useEffect(() => {
    // console.log('se renderiza');
    async function getVersion() {
      await firestore
        .collection('varsionsApp')
        // .where('user_id', '==', neededUserId)
        // .where('created_at', '>', startDate)
        .orderBy('created_at', 'desc')
        .limit(5)
        .onSnapshot((queryS) => {
          const dat = [];
          queryS.forEach((doc) => {
            dat.push({
              id: doc.id,
              ...doc.data()
            });
          });
          setVersions(dat);
        });
    }
    getVersion();
  }, []);

  useEffect(() => {
    const versionApp = localStorage.getItem('versionApp');

    if (versionApp && versions.length) {
      const lastVersion = versions[0];
      setVersionApp(versionApp);

      if (lastVersion.version !== versionApp) {
        setDialogVersion(true);
      }
    } else if (!versionApp && versions.length) {
      const lastVersion = versions[0];
      setVersionApp(lastVersion.version);
      localStorage.setItem('versionApp', lastVersion.version);
      // setDialogVersion(true);
    }
  }, [versions]);

  return (
    <VersionContext.Provider value={{ updateVersion, versionApp }}>
      <DialogUpdateVersionContext open={dialogVersion} onClose={setDialogVersion} updateVersion={updateVersion} />
      {children}
    </VersionContext.Provider>
  );
}

export default VersionProvider;
